export const getCinsaultFranceData = () => ({
  name: "Cinsault",
  country: "France",
  description: "Le Cinsault est principalement cultivé dans le sud de la France, particulièrement en Provence et dans le Languedoc.",
  regions: [
    { name: "Provence", area: "2,500 ha", percentage: "45%", description: "Cépage principal des rosés" },
    { name: "Languedoc-Roussillon", area: "1,800 ha", percentage: "32%", description: "Assemblage et vins rosés" },
    { name: "Côtes du Rhône", area: "800 ha", percentage: "14%", description: "Assemblage traditionnel" },
    { name: "Corbières", area: "300 ha", percentage: "5%", description: "Vins d'assemblage" },
    { name: "Autres", area: "200 ha", percentage: "4%", description: "Dispersé dans le sud" }
  ],
  mapAreas: [
    { region: "Provence", x: 65, y: 70, color: "#4B164C", size: 7 },
    { region: "Languedoc-Roussillon", x: 50, y: 65, color: "#6d2c7a", size: 6 },
    { region: "Côtes du Rhône", x: 58, y: 55, color: "#8a4a8a", size: 3 },
    { region: "Corbières", x: 48, y: 68, color: "#a768a6", size: 2 }
  ],
  subregions: {
    provence: {
      name: "Provence",
      description: "Le Cinsault de Provence est principalement utilisé pour produire des vins rosés élégants et fruités.",
      characteristics: {
        aromas: "Fruits rouges, fraise, framboise, notes florales",
        body: "Corps léger à moyen",
        tannins: "Tannins doux et soyeux",
        aging: "Vieillissement court (2-5 ans)"
      },
      terroir: {
        climate: "Climat méditerranéen chaud",
        soil: "Sols calcaires et galets roulés",
        viticulture: "Rendements modérés, vendanges précoces"
      },
      differentiators: [
        "Fruité intense et frais",
        "Tannins naturellement doux",
        "Style élégant et accessible",
        "Cépage idéal pour les rosés"
      ],
      foodPairing: "Poissons, fruits de mer, salades, fromages frais"
    }
  }
}); 